/**
 * UP CEL — Catálogo de marcas, modelos e checklist inteligente para OS.
 * Data static — atualizável a qualquer momento.
 */

export const BRAND_MODELS = {
  Apple: [
    "iPhone 6", "iPhone 6 Plus", "iPhone 6s", "iPhone 6s Plus", "iPhone SE (1ª ger)",
    "iPhone 7", "iPhone 7 Plus", "iPhone 8", "iPhone 8 Plus",
    "iPhone X", "iPhone XR", "iPhone XS", "iPhone XS Max",
    "iPhone 11", "iPhone 11 Pro", "iPhone 11 Pro Max",
    "iPhone SE (2ª ger)", "iPhone 12 mini", "iPhone 12", "iPhone 12 Pro", "iPhone 12 Pro Max",
    "iPhone 13 mini", "iPhone 13", "iPhone 13 Pro", "iPhone 13 Pro Max",
    "iPhone SE (3ª ger)", "iPhone 14", "iPhone 14 Plus", "iPhone 14 Pro", "iPhone 14 Pro Max",
    "iPhone 15", "iPhone 15 Plus", "iPhone 15 Pro", "iPhone 15 Pro Max",
    "iPhone 16", "iPhone 16 Plus", "iPhone 16 Pro", "iPhone 16 Pro Max",
  ],
  Samsung: [
    "Galaxy A03", "Galaxy A03 Core", "Galaxy A04", "Galaxy A04e", "Galaxy A05", "Galaxy A05s",
    "Galaxy A10", "Galaxy A10s", "Galaxy A11", "Galaxy A12", "Galaxy A13", "Galaxy A14", "Galaxy A15",
    "Galaxy A20", "Galaxy A20s", "Galaxy A21s", "Galaxy A22", "Galaxy A23", "Galaxy A24",
    "Galaxy A30", "Galaxy A30s", "Galaxy A31", "Galaxy A32", "Galaxy A33", "Galaxy A34", "Galaxy A35",
    "Galaxy A50", "Galaxy A51", "Galaxy A52", "Galaxy A53", "Galaxy A54", "Galaxy A55",
    "Galaxy A70", "Galaxy A71", "Galaxy A72", "Galaxy A73",
    "Galaxy M14", "Galaxy M23", "Galaxy M32", "Galaxy M52", "Galaxy M53", "Galaxy M54",
    "Galaxy S8", "Galaxy S8+", "Galaxy S9", "Galaxy S9+", "Galaxy S10", "Galaxy S10+", "Galaxy S10e",
    "Galaxy S20", "Galaxy S20+", "Galaxy S20 Ultra", "Galaxy S20 FE",
    "Galaxy S21", "Galaxy S21+", "Galaxy S21 Ultra", "Galaxy S21 FE",
    "Galaxy S22", "Galaxy S22+", "Galaxy S22 Ultra",
    "Galaxy S23", "Galaxy S23+", "Galaxy S23 Ultra", "Galaxy S23 FE",
    "Galaxy S24", "Galaxy S24+", "Galaxy S24 Ultra",
    "Galaxy Note 8", "Galaxy Note 9", "Galaxy Note 10", "Galaxy Note 10+", "Galaxy Note 20", "Galaxy Note 20 Ultra",
    "Galaxy Z Flip 3", "Galaxy Z Flip 4", "Galaxy Z Flip 5",
    "Galaxy Z Fold 3", "Galaxy Z Fold 4", "Galaxy Z Fold 5",
  ],
  Motorola: [
    "Moto E6", "Moto E6i", "Moto E6 Plus", "Moto E7", "Moto E7i Power", "Moto E7 Plus",
    "Moto E13", "Moto E14", "Moto E22", "Moto E32", "Moto E40", "Moto E5", "Moto E5 Plus",
    "Moto G4", "Moto G5", "Moto G5s", "Moto G6", "Moto G6 Play", "Moto G6 Plus",
    "Moto G7", "Moto G7 Play", "Moto G7 Plus", "Moto G7 Power",
    "Moto G8", "Moto G8 Play", "Moto G8 Plus", "Moto G8 Power",
    "Moto G9 Play", "Moto G9 Plus", "Moto G9 Power",
    "Moto G10", "Moto G20", "Moto G30", "Moto G50",
    "Moto G22", "Moto G32", "Moto G42", "Moto G52", "Moto G62", "Moto G72", "Moto G82",
    "Moto G23", "Moto G53", "Moto G73", "Moto G84",
    "Moto G24", "Moto G34", "Moto G54", "Moto G64", "Moto G85",
    "Moto Edge 20", "Moto Edge 30", "Moto Edge 40", "Moto Edge 50",
    "Moto One", "Moto One Vision", "Moto One Action", "Moto One Fusion",
    "Moto Z3 Play", "Moto Z4", "Razr 40", "Razr 50",
  ],
  Xiaomi: [
    "Redmi 9", "Redmi 9A", "Redmi 9C", "Redmi 9T", "Redmi 10", "Redmi 10A", "Redmi 10C",
    "Redmi 12", "Redmi 12C", "Redmi 13", "Redmi 13C",
    "Redmi Note 8", "Redmi Note 8 Pro", "Redmi Note 9", "Redmi Note 9 Pro", "Redmi Note 9S",
    "Redmi Note 10", "Redmi Note 10 Pro", "Redmi Note 10S",
    "Redmi Note 11", "Redmi Note 11 Pro", "Redmi Note 11S",
    "Redmi Note 12", "Redmi Note 12 Pro", "Redmi Note 12S",
    "Redmi Note 13", "Redmi Note 13 Pro", "Redmi Note 13 Pro+",
    "POCO X3", "POCO X3 Pro", "POCO X4 Pro", "POCO X5", "POCO X5 Pro", "POCO X6", "POCO X6 Pro",
    "POCO M3", "POCO M4 Pro", "POCO M5", "POCO M6", "POCO F3", "POCO F4", "POCO F5", "POCO F6",
    "Mi 10", "Mi 11", "Mi 11 Lite", "Mi 12", "Xiaomi 13", "Xiaomi 13T", "Xiaomi 14", "Xiaomi 14T",
  ],
  LG: ["K12+", "K22", "K40s", "K41s", "K50s", "K52", "K62", "K71", "Velvet", "Wing"],
  Asus: [
    "Zenfone 5", "Zenfone 5Z", "Zenfone 6", "Zenfone 7", "Zenfone 8", "Zenfone 9", "Zenfone 10",
    "ROG Phone 5", "ROG Phone 6", "ROG Phone 7", "ROG Phone 8",
  ],
  Nokia: ["Nokia G10", "Nokia G20", "Nokia G21", "Nokia G22", "Nokia G50", "Nokia X10", "Nokia X20", "Nokia C21"],
  Realme: [
    "Realme 8", "Realme 8 Pro", "Realme 9", "Realme 9 Pro", "Realme 10", "Realme 11", "Realme 12",
    "Realme GT", "Realme GT Neo", "Realme Narzo 50",
  ],
  OnePlus: ["OnePlus 8", "OnePlus 8T", "OnePlus 9", "OnePlus 9 Pro", "OnePlus 10", "OnePlus 10 Pro", "OnePlus 11", "OnePlus 12"],
  Huawei: ["P30", "P30 Pro", "P40", "P40 Pro", "P50", "P50 Pro", "P60", "Mate 40", "Nova 9", "Nova 11"],
  Outros: [],
};

// Recursos por prefixo/família (para montar checklist inteligente)
const HAS_FACE_ID = (model = "") => {
  const m = model.toLowerCase();
  // iPhone X em diante têm Face ID (exceto SE 2/3 e iPhone 8/7/6)
  if (!m.startsWith("iphone")) return false;
  if (/iphone (se|8|7|6)/.test(m)) return false;
  return /iphone (x|xr|xs|11|12|13|14|15|16)/.test(m);
};

const HAS_TOUCH_ID = (model = "") => {
  const m = model.toLowerCase();
  if (m.includes("se")) return true; // iPhone SE
  return /iphone (6|7|8)/.test(m);
};

const HAS_WIRELESS_CHARGE = (brand, model = "") => {
  const m = model.toLowerCase();
  if (brand === "Apple") return /iphone (8|x|xr|xs|11|12|13|14|15|16)/.test(m);
  if (brand === "Samsung") {
    return /(s8|s9|s10|s20|s21|s22|s23|s24|note 8|note 9|note 10|note 20|z flip|z fold)/i.test(model);
  }
  if (brand === "Motorola") return /(edge|razr)/i.test(model);
  if (brand === "Xiaomi") return /(mi 10|mi 11|mi 12|xiaomi 13|xiaomi 14|poco f)/i.test(model);
  return false;
};

const HAS_FINGERPRINT = (brand, model = "") => {
  if (brand === "Apple") return HAS_TOUCH_ID(model);
  // A maioria dos Android modernos tem digital
  return true;
};

const HAS_DUAL_CAMERA = (brand, model = "") => {
  const m = model.toLowerCase();
  // Praticamente todos os celulares modernos têm câmera dupla ou mais
  if (brand === "Apple") return /iphone (7 plus|8 plus|x|xr|xs|11|12|13|14|15|16)/.test(m);
  return true;
};

/**
 * Retorna a checklist adequada ao modelo escolhido.
 * Cada item: { key, label, required }
 */
export function checklistFor(brand, model) {
  const base = [
    { key: "tela", label: "Tela / Display" },
    { key: "touch", label: "Touch" },
    { key: "camera_traseira", label: "Câmera traseira" },
    { key: "camera_frontal", label: "Câmera frontal" },
    { key: "alto_falante", label: "Alto-falante" },
    { key: "microfone", label: "Microfone" },
    { key: "botao_power", label: "Botão Power" },
    { key: "botao_volume", label: "Botões de Volume" },
    { key: "wifi", label: "Wi-Fi" },
    { key: "bluetooth", label: "Bluetooth" },
    { key: "bateria", label: "Bateria" },
    { key: "carregamento", label: "Carregamento (cabo)" },
  ];

  if (HAS_WIRELESS_CHARGE(brand, model)) {
    base.push({ key: "carregamento_inducao", label: "Carregamento por indução" });
  }
  if (HAS_FACE_ID(model)) {
    base.push({ key: "face_id", label: "Face ID" });
  }
  if (HAS_TOUCH_ID(model)) {
    base.push({ key: "touch_id", label: "Touch ID" });
  } else if (HAS_FINGERPRINT(brand, model)) {
    base.push({ key: "leitor_digital", label: "Leitor de digital" });
  }
  if (HAS_DUAL_CAMERA(brand, model)) {
    base.push({ key: "flash", label: "Flash / lanterna" });
  }
  // Sinal / rede
  base.push({ key: "sinal", label: "Sinal / Chip / Rede" });
  base.push({ key: "vibracao", label: "Vibração" });

  return base;
}

export const CHECKLIST_STATUS = [
  { value: "ok", label: "Funcionando", cls: "bg-emerald-100 text-emerald-700 border-emerald-300" },
  { value: "ruim", label: "Ruim", cls: "bg-amber-100 text-amber-700 border-amber-300" },
  { value: "quebrado", label: "Não funciona", cls: "bg-red-100 text-red-700 border-red-300" },
];

export const STATUS_LABEL = {
  ok: "Funcionando",
  ruim: "Ruim",
  quebrado: "Não funciona",
};
